<script setup lang="ts">
import { computed, inject, toRef } from 'vue';
import type { IColumnDefinition } from './types';
import type { FooterTotalsRowModel, TableModel } from './model';
import { useColumn, useCellFormatter } from './composables';

const props = defineProps<{
  row: FooterTotalsRowModel;
  column: IColumnDefinition;
}>();

const model = inject<TableModel>('model');
if (!model) {
  throw new Error('ItpDataTableFooterTotalsCell missing model injection');
}

const { columnStyle, columnClasses } = useColumn({
  column: props.column,
  options: model.options,
});

const { formatter, isCustom } = useCellFormatter(toRef(props, 'column'));

const cellValue = computed(() => props.row.getValue(props.column.field));
const display = computed(() => props.row.displayTotalsForColumn(props.column));

const globs = computed(() => model.options.globs || {});
const messages = computed(() => model.options.messages || {});

const finalClasses = computed(() => ({
  ...columnClasses.value,
  'itp-datatable__table-cell': true,
  'py-2': true,
  'fw-bold': true,
}));
</script>

<template>
  <td :class="finalClasses" :style="columnStyle">
    <span v-if="display">
      <component
        :is="formatter"
        v-if="isCustom"
        :value="cellValue"
        :row="{}"
        :column="column"
        :globs="globs"
        :messages="messages"
      />
      <component
        :is="formatter"
        v-else
        :value="cellValue"
        :row="{}"
        :column="column"
      />
    </span>
  </td>
</template>
